module.exports = __webpack_public_path__ + "static/media/Facebook.8b42ac6f.svg";